import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { validateEmail } from '../../../../../../../../../shared/utils/validators';

import TextInput from '../../../../components/lib/TextInput';
import ProjectInput from './components/ProjectInput';

import { Button } from 'hosman-material';
import { S_EyeSlash, S_Eye } from 'hosman-material';

const SignupForm = ({ formValues, setFormValues, setLogin, submitForm, formErrors, setFormErrors, isSubmitting }) => {
  const [passwordConfirmation, setPasswordConfirmation] = useState('')
  const [showPasswords, setShowPasswords] = useState({ password: false, passwordConfirmation: false });
  
  const handleSetLogin = () => {
    setFormErrors({})
    setLogin(true)
  }

  const handleSubmit = () => {    
    if (!validateInputs()) return;
    
    submitForm();
  }

  const validateInputs = () => {
    const errors = {};

    if (!validateEmail(formValues.email)) {
      errors.email = ["L'email n'est pas valide"];
    }

    if (formValues.password.length < 8) {
      errors.password = ['Le mot de passe doit contenir au minimum 8 caractères'];
    }

    if (formValues.password !== passwordConfirmation) {
      errors.passwordConfirmation = 'Les mots de passe ne sont pas identiques';
    }

    if (!formValues.project) {
      errors.project = 'Veuillez sélectionner une raison';
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (!isSubmitting) handleSubmit();
      }}
      className='flex flex-col gap-3 py-3 w-full'
    >
      <p className='font-semibold mb-3'>Débloquez toute la donnée en créant un compte Hosman</p>
      
      <div className='flex flex-col gap-1'>
        <TextInput 
          name='email' 
          type='email' 
          label='E-mail' 
          value={formValues.email} 
          onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
        />

        {formErrors.email && <p className='text-sm text-ih-red'>{formErrors.email[0] == "n'est pas valide" ? "L'e-mail n'est pas valide" : formErrors.email[0]}</p>}
      </div>

      <div className='flex flex-col gap-1'>
        <div className='relative'>
          <TextInput
            name='password' 
            type={showPasswords.password ? 'text' : 'password'}
            label='Mot de passe' 
            value={formValues.password} 
            onChange={(e) => setFormValues({ ...formValues, password: e.target.value })}
          />

          <FontAwesomeIcon icon={showPasswords.password ? S_EyeSlash : S_Eye} className='text-white absolute top-12 right-2 cursor-pointer' onClick={() => setShowPasswords({ ...showPasswords, password: !showPasswords.password })} />
        </div>

        {formErrors.password && <p className='text-sm text-ih-red'>{formErrors.password[0]}</p>}
      </div>

      <div className='flex flex-col gap-1'>
        <div className='relative'>
          <TextInput
            name='password_confirmation' 
            type={showPasswords.passwordConfirmation ? 'text' : 'password'}
            label='Confirmer le nouveau mot de passe'
            value={passwordConfirmation} 
            onChange={(e) => setPasswordConfirmation(e.target.value)}
          />

          <FontAwesomeIcon icon={showPasswords.passwordConfirmation ? S_EyeSlash : S_Eye} className='text-white absolute top-12 right-2 cursor-pointer' onClick={() => setShowPasswords({ ...showPasswords, passwordConfirmation: !showPasswords.passwordConfirmation })} />
        </div>

        {formErrors.passwordConfirmation && <p className='text-sm text-ih-red'>{formErrors.passwordConfirmation}</p>}
      </div>

      <ProjectInput formValues={formValues} setFormValues={setFormValues} formErrors={formErrors} />

      <p className='text-white hover:text-white/80 text-sm underline cursor-pointer transition-all w-max my-5' onClick={() => handleSetLogin()}>Déjà un compte?</p>

      <Button 
        label='Créer mon compte' 
        buttonType='submit' 
        isLoading={isSubmitting} 
        onClick={() => handleSubmit()}
      />
    </form>
  )
}

export default SignupForm;
